export default "__VITE_PUBLIC_ASSET__3e5992ae__"